// src/services/profile.service.js

import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class ProfileService {
  submitProfile(formData) {
    // authHeader sets Authorization: Bearer <token> if you use JWT/Sanctum
    return axios.post(API_URL + "candidate-profile", formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

   getProfile() {
    return axios.get(API_URL + "candidate-profile", { headers: authHeader() });
  }
}

export default new ProfileService();
